var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t("chats.attach-file")))])]),
      _vm._v(" "),
      _c("base-select", {
        staticClass: "mt-1",
        attrs: {
          clearable: "",
          avoidDefaultSort: "",
          loading: false,
          options: _vm.fileTags,
          valueProp: "id",
          label: "name",
          placeholder: _vm.$t("chats.select-file-type")
        },
        model: {
          value: _vm.fileTag,
          callback: function($$v) {
            _vm.fileTag = $$v
          },
          expression: "fileTag"
        }
      }),
      _vm._v(" "),
      _vm.fileTag
        ? _c(
            "div",
            { staticClass: "mt-2" },
            [
              _c(
                "base-button",
                {
                  staticClass: "attach-button",
                  on: {
                    click: function($event) {
                      return _vm.$refs.fileInput.click()
                    }
                  }
                },
                [
                  _c("b-icon-paperclip", { staticClass: "mr-2" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("chats.select-file")))]),
                  _c("input", {
                    ref: "fileInput",
                    staticClass: "d-none",
                    attrs: { type: "file" },
                    on: {
                      change: function($event) {
                        return _vm.uploadFile($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.files.length
        ? _c(
            "div",
            { staticClass: "mt-2" },
            _vm._l(_vm.files, function(file, index) {
              return _c(
                "div",
                { key: index, staticClass: "file-item" },
                [
                  _c("span", { staticClass: "file-icon" }, [
                    _vm._v(_vm._s(_vm.getFileIcon(file)))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "file-name" }, [
                    _vm._v(_vm._s(file.name))
                  ]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      attrs: { red: "" },
                      on: {
                        click: function($event) {
                          return _vm.removeFile(index)
                        }
                      }
                    },
                    [_c("b-icon-trash")],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showLink ? _c("div") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58f5f77f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f5f77f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/AttachFile.vue
// module id = 4091
// module chunks = 14